import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ActionTypeHandlerBaseSmartEnum, ActionTypeHandlerEnum } from './action-type-handler.enum';
import { OutputEmitterRef, Type } from '@angular/core';
import { IActionExecutedEvent, IBaseActionConfig } from '../../types';

export interface IDialogActionConfig<TEntity, TComponentType = unknown, TData = unknown>
  extends IBaseActionConfig<IDialogHandlerConfig<TEntity, TComponentType, TData>> {
  handlerType: ActionTypeHandlerEnum.DIALOG;
}

export interface IDialogHandlerConfig<TEntity, TComponentType = unknown, TData = unknown> {
  service: DialogService;
  componentType: Type<TComponentType>;
  configResolver: (item?: TEntity) => DynamicDialogConfig<TData>;
  onClose?: (item?: TEntity) => void;
  styleClass?: 'responsive-dialog-width';
}

export class DialogActionTypeHandlerSmartEnum extends ActionTypeHandlerBaseSmartEnum {
  public static Dialog = new DialogActionTypeHandlerSmartEnum(ActionTypeHandlerEnum.DIALOG);

  constructor(name: string) {
    super(name);
  }

  override execute<TEntity, TComponentType = unknown, TData = unknown>(
    config: IDialogActionConfig<TEntity, TComponentType, TData>,
    item?: TEntity,
    actionExecuted?: OutputEmitterRef<IActionExecutedEvent<TEntity>>
  ) {
    if (!config.handlerConfig.service) {
      throw new Error(`Dialog handler requires a valid DialogService`);
    }

    const dialogConfig = config.handlerConfig.configResolver(item);

    // If styleClass is not set, set it to 'responsive-dialog-width'
    if (!dialogConfig.styleClass) {
      dialogConfig.styleClass = 'responsive-dialog-width';
    }

    let ref = config.handlerConfig.service.open(
      config.handlerConfig.componentType,
      dialogConfig
    );

    ref?.onClose?.subscribe((newItemOrUpdated?: boolean | null | TEntity) => {
      if (!!newItemOrUpdated || newItemOrUpdated === null) {
        let effectedItem = item || (newItemOrUpdated as TEntity);
        actionExecuted?.emit({ config, item: effectedItem });
        config.handlerConfig.onClose?.(item || effectedItem);
      }
    });
  }
}
